module.exports = __webpack_public_path__ + "static/media/PrintLabel.8b9d897f.png";